import { create } from 'zustand';

export type WifiProfile = {
    id: string;
    networkName: string;
    ssid: string;
    password: string;
};

interface BlockWifiState {
    profiles: WifiProfile[];
    addProfile: (profile: WifiProfile) => void;
    updateProfile: (id: string, profile: Partial<WifiProfile>) => void;
    removeProfile: (id: string) => void;
    setProfiles: (profiles: WifiProfile[]) => void;
}

export const useBlockWifiStore = create<BlockWifiState>((set) => ({
    profiles: [],
    addProfile: (profile) => set((s) => ({ profiles: [...s.profiles, profile] })),
    updateProfile: (id, profile) =>
        set((s) => ({ profiles: s.profiles.map((p) => (p.id === id ? { ...p, ...profile } : p)) })),
    removeProfile: (id) => set((s) => ({ profiles: s.profiles.filter((p) => p.id !== id) })),
    setProfiles: (profiles) => set({ profiles }),
}));
